import {assert} from 'Asserts';

export function getProcedureRunDesignFlowchartNodeId({
  conditionIndex,
  replicateIndex,
  methodId,
}: {
  conditionIndex: number;
  replicateIndex: number;
  methodId: string;
}): string {
  return `${conditionIndex}-${replicateIndex}-${methodId}`;
}

export function parseProcedureRunDesignFlowchartNodeId(nodeId: string): {
  conditionIndex: number;
  replicateIndex: number;
  methodId: string;
} {
  const [conditionIndexPart, replicateIndexPart, methodId] = nodeId.split('-');
  assert(
    conditionIndexPart != null && replicateIndexPart != null && methodId != null,
    `Malformed flowchart node id: ${nodeId}`
  );
  const conditionIndex = Number(conditionIndexPart);
  const replicateIndex = Number(replicateIndexPart);
  assert(
    Number.isInteger(conditionIndex) && conditionIndex >= 0,
    `Invalid condition index in node id: ${nodeId}`
  );
  assert(
    Number.isInteger(replicateIndex) && replicateIndex >= 0,
    `Invalid replicate index in node id: ${nodeId}`
  );
  return {
    conditionIndex,
    replicateIndex,
    methodId,
  };
}
